import ApiService from "../api.service";
const PurchaseRequisitionService = {
  GetList(Search, SortColumn, OrderType, PageNumber, PageLimit,OblastId,RegionId,OrganizationId) {
    return ApiService.get(
      `/PurchaseRequisition/GetList?Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&OblastId=${OblastId}&RegionId=${RegionId}&OrganizationId=${OrganizationId}`
    );
  },
  Get(id) {
    return ApiService.get(`/PurchaseRequisition/Get?id=${id}`);
  },
  GetDetail(id) {
    return ApiService.get(`/PurchaseRequisition/GetDetail?id=${id}`);
  },
  Update(data) {
    return ApiService.post(`/PurchaseRequisition/Update`, data);
  },
  Delete(id) {
    return ApiService.delete(`/PurchaseRequisition/Delete?id=${id}`);
  },
  Approve(id) {
    return ApiService.post(`/PurchaseRequisition/Approve?id=${id}`);
  },
  Send(id) {
    return ApiService.post(`/PurchaseRequisition/Send?id=${id}`);
  },
  Accept(id) {
    return ApiService.post(`/PurchaseRequisition/Accept?id=${id}`);
  },
  Reject(data) {
    return ApiService.post(`/PurchaseRequisition/Reject`, data);
  },
  Estimate(id) {
    return ApiService.post(`/PurchaseRequisition/Estimate?id=${id}`);
  },
  CancelApproval(id) {
    return ApiService.post(`/PurchaseRequisition/CancelApproval?id=${id}`);
  },
  GetPurReqTable(id) {
    return ApiService.get(`/PurchaseRequisition/GetPurReqTable?id=${id}`);
  },
  UpdatePurReqTable(data) {
    return ApiService.post(`/PurchaseRequisition/UpdatePurReqTable`, data);
  },
  GetListForOtherStatus(
    Search,
    SortColumn,
    OrderType,
    PageNumber,
    PageLimit,
    StatusId,OblastId,RegionId,OrganizationId
  ) {
    return ApiService.get(
      `/PurchaseRequisition/GetListForOtherStatus?Search=${Search}&SortColumn=${SortColumn}&OrderType=${OrderType}&PageNumber=${PageNumber}&PageLimit=${PageLimit}&StatusId=${StatusId}&OblastId=${OblastId}&RegionId=${RegionId}&OrganizationId=${OrganizationId}`
    );
  },
  GetStatisticsOfPriceInProduct(productId, onDate) {
    return ApiService.get(
      `/PurchaseRequisition/GetStatisticsOfPriceInProduct?productId=${productId}&onDate=${onDate}`
    );
  },
};
export default PurchaseRequisitionService;
